export var getEmptyCity = function () {
    var resultViewData = {
        id: "",
        name: "",
    };
    return resultViewData;
};
